import { render, staticRenderFns } from "./DashboardCourseProgress.vue?vue&type=template&id=aaebbc84&"
import script from "./DashboardCourseProgress.vue?vue&type=script&lang=js&"
export * from "./DashboardCourseProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports